/**
 * Синхронизация цветов бренда между JS и CSS
 * Устанавливает CSS переменные на основе значений из constants/colors.js
 * 
 * Теперь работает с новой системой Design Tokens:
 * - Обновляет примитивы (--palette-red-main) из constants/colors.js
 * - Семантика (--primary-main) уже ссылается на примитивы в theme.css
 */

import { BRAND_COLORS } from '@/constants/colors'

/**
 * Устанавливает CSS переменные для цветов бренда
 * Вызывается при загрузке приложения
 * 
 * Обновляет примитивы в theme.css, семантика обновится автоматически
 */
export function syncBrandColors() {
  const root = document.documentElement
  
  // Обновляем примитивы (Уровень 1) из constants/colors.js
  root.style.setProperty('--palette-red-main', BRAND_COLORS.PRIMARY)
  root.style.setProperty('--palette-red-light', BRAND_COLORS.LIGHT)
  root.style.setProperty('--palette-red-dark', BRAND_COLORS.DARK)
  root.style.setProperty('--palette-red-darker', BRAND_COLORS.DARKER)
  
  // Обратная совместимость: старые переменные (алиасы)
  root.style.setProperty('--brand-primary', BRAND_COLORS.PRIMARY)
  root.style.setProperty('--color-brand', BRAND_COLORS.PRIMARY)
  root.style.setProperty('--color-brand-accent', BRAND_COLORS.ACCENT)
  root.style.setProperty('--color-brand-dark', BRAND_COLORS.DARK)
  root.style.setProperty('--color-brand-darker', BRAND_COLORS.DARKER)
  root.style.setProperty('--color-brand-light', BRAND_COLORS.LIGHT)
  
  // Градиенты (используют семантику, которая ссылается на примитивы)
  root.style.setProperty('--brand-gradient', BRAND_COLORS.GRADIENT.PRIMARY)
  
  // RGBA варианты для теней (обновляем примитивы теней)
  root.style.setProperty('--shadow-primary-01', BRAND_COLORS.RGBA.SHADOW_LIGHT)
  root.style.setProperty('--shadow-primary-015', BRAND_COLORS.RGBA.SHADOW_LIGHT)
  root.style.setProperty('--shadow-primary-02', BRAND_COLORS.RGBA.SHADOW_MEDIUM)
  root.style.setProperty('--shadow-primary-025', BRAND_COLORS.RGBA.SHADOW_MEDIUM)
  root.style.setProperty('--shadow-primary-03', BRAND_COLORS.RGBA.SHADOW_STRONG)
  
  // Обратная совместимость: старые названия теней
  root.style.setProperty('--brand-shadow-light', BRAND_COLORS.RGBA.SHADOW_LIGHT)
  root.style.setProperty('--brand-shadow-medium', BRAND_COLORS.RGBA.SHADOW_MEDIUM)
  root.style.setProperty('--brand-shadow-strong', BRAND_COLORS.RGBA.SHADOW_STRONG)
  root.style.setProperty('--brand-shadow-very-strong', BRAND_COLORS.RGBA.SHADOW_VERY_STRONG)
  root.style.setProperty('--brand-background-light', BRAND_COLORS.RGBA.BACKGROUND_LIGHT)
  
  // Обновляем тени для кнопок и стеклянных эффектов
  root.style.setProperty('--button-shadow-hover', `0 12px 32px ${BRAND_COLORS.RGBA.SHADOW_MEDIUM}`)
  root.style.setProperty('--button-shadow-hover-light', `0 4px 12px ${BRAND_COLORS.RGBA.SHADOW_LIGHT}`)
  root.style.setProperty('--glass-shadow-focus', `0 4px 16px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.08), 0 0 0 3px ${BRAND_COLORS.RGBA.SHADOW_LIGHT}`)
}

